// Separate this into its own file to prevent circular dependencies
export const getElements = (state) => state.get('elements');
